import localFont from "next/font/local";

/**
 * NOTE: 폴백 폰트들은 각각 localFont의 fallback 속성에 직접 인라인으로 넣어야 함
 * NOTE: 아래 코드는 사용하지 않지만 남겨둠
 */
/**
const fallbackFonts = [
  "-apple-system",
  "BlinkMacSystemFont",
  "system-ui",
  "Roboto",
  "Helvetica Neue",
  "Segoe UI",
  "Apple SD Gothic Neo",
  "Noto Sans KR",
  "Malgun Gothic",
  "Apple Color Emoji",
  "Segoe UI Emoji",
  "Segoe UI Symbol",
  "sans-serif",
];

const fallbackFontsString = fallbackFonts
  .map((fallback) => (fallback.includes(" ") ? `"${fallback}"` : fallback))
  .join(", ");
*/

/**
 * 각 localFont의 fallback 속성은 직접 인라인으로 적어야 한다
 *
 * Font loader values must be explicitly written literals.
 */
export const poppins_400 = localFont({
  src: "./fonts/Poppins/Poppins-Regular.woff2",
  weight: "400",
  style: "normal",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});
export const poppins_500 = localFont({
  src: "./fonts/Poppins/Poppins-Medium.woff2",
  weight: "500",
  style: "normal",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});
export const poppins_600 = localFont({
  src: "./fonts/Poppins/Poppins-SemiBold.woff2",
  weight: "600",
  style: "normal",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});
export const poppins_700 = localFont({
  src: "./fonts/Poppins/Poppins-Bold.woff2",
  weight: "700",
  style: "normal",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});

const poppinsFonts = localFont({
  src: [
    {
      path: "./fonts/Poppins/Poppins-Light.woff2",
      weight: "300",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-LightItalic.woff2",
      weight: "300",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-Italic.woff2",
      weight: "400",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-Medium.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-MediumItalic.woff2",
      weight: "500",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-SemiBold.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-SemiBoldItalic.woff2",
      weight: "600",
      style: "italic",
    },
    {
      path: "./fonts/Poppins/Poppins-Bold.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "./fonts/Poppins/Poppins-BoldItalic.woff2",
      weight: "700",
      style: "italic",
    },
  ],
  display: "swap",
  variable: "--font-poppins",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});

const PretendardFonts = localFont({
  src: [
    {
      path: "./fonts/Pretendard/Pretendard-Thin.woff2",
      weight: "100",
    },
    {
      path: "./fonts/Pretendard/Pretendard-ExtraLight.woff2",
      weight: "200",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Light.woff2",
      weight: "300",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Regular.woff2",
      weight: "400",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Medium.woff2",
      weight: "500",
    },
    {
      path: "./fonts/Pretendard/Pretendard-SemiBold.woff2",
      weight: "600",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Bold.woff2",
      weight: "700",
    },
    {
      path: "./fonts/Pretendard/Pretendard-ExtraBold.woff2",
      weight: "800",
    },
    {
      path: "./fonts/Pretendard/Pretendard-Black.woff2",
      weight: "900",
    },
  ],
  display: "swap",
  variable: "--font-pretendard",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});

const InterFonts = localFont({
  src: [
    {
      path: "./fonts/Inter/Inter_18pt-Light.ttf",
      weight: "300",
      style: "normal",
    },
    {
      path: "./fonts/Inter/Inter_18pt-Regular.ttf",
      weight: "400",
      style: "normal",
    },
    {
      path: "./fonts/Inter/Inter_18pt-SemiBold.ttf",
      weight: "600",
      style: "normal",
    },
    {
      path: "./fonts/Inter/Inter_18pt-Bold.ttf",
      weight: "700",
      style: "normal",
    },
    {
      path: "./fonts/Inter/Inter_18pt-ExtraBold.ttf",
      weight: "800",
      style: "normal",
    },
    {
      path: "./fonts/Inter/Inter_18pt-Black.ttf",
      weight: "900",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--font-inter",
  fallback: [
    "-apple-system",
    "BlinkMacSystemFont",
    "system-ui",
    "Roboto",
    "Helvetica Neue",
    "Segoe UI",
    "Apple SD Gothic Neo",
    "Noto Sans KR",
    "Malgun Gothic",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
    "sans-serif",
  ],
});

export const poppins = {
  ...poppinsFonts,
  string: poppinsFonts.style.fontFamily,
};

export const Pretendard = {
  ...PretendardFonts,
  string: PretendardFonts.style.fontFamily,
};

export const Inter = {
  ...InterFonts,
  string: InterFonts.style.fontFamily,
};
